import { CarouselOptions } from '@rdss/elements'

export const recommendationSliderOptions: CarouselOptions = {
    direction: 'ltr',
    perPage: 5,
    arrows: false,
    omitEnd: true,
    breakpoints: {
        1440: {
            perPage: 4,
            arrows: false,
        },
        1024: {
            perPage: 3,
            arrows: true,
        },
        960: {
            perPage: 3,
            arrows: true,
        },
        768: {
            perPage: 2,
            arrows: true,
        },
        480: {
            perPage: 1,
            arrows: true,
        },
    },
} as CarouselOptions
